var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.565 2.137c2.406 0 4.384 1.918 4.384 4.294 0 .9-.285 1.738-.815 2.477l-.429.6-.611.419c-.755.52-1.611.799-2.529.799-2.406 0-4.383-1.918-4.383-4.295 0-2.376 1.977-4.294 4.383-4.294Zm0-2.137C2.936 0 0 2.876 0 6.431c0 3.556 2.936 6.432 6.565 6.432 1.407 0 2.712-.44 3.793-1.199l3.079 3.016c.204.2.49.32.774.32.286 0 .571-.1.775-.32l.02-.02c.429-.419.49-1.118 0-1.518l-3.078-2.995c.754-1.06 1.223-2.337 1.223-3.716C13.131 2.876 10.195 0 6.565 0Z"
  })));
};
export default SvgSearch;